import React from 'react';
import { useHistory } from 'react-router-dom';

import { RequestResetPasswordEmail } from 'src/components/user-flow/forgot-password';

export default function ForgotPasswordRoute(): JSX.Element {
  const history = useHistory();

  function handleRedirectToLogin(): void {
    history.push('/login');
  }

  // Preserve the original shared render-scoped callback for both completion paths.
  // eslint-disable-next-line react/jsx-no-bind
  return <RequestResetPasswordEmail onSuccess={handleRedirectToLogin} onClose={handleRedirectToLogin} />;
}
